module.exports = __webpack_public_path__ + "static/media/Placaj ceramic Klinker Cairo.cc773aa1.jpg";